import { SmartSendItemApiModel } from '~/lib/api/smartsend/types';
import { GetExternalTrackingNumber } from './SmartSendSummaryGenerator';

export function containsSearchTerm(x: SmartSendItemApiModel, filterTerm: string) {
  return (
    x.Id?.indexOf(filterTerm) > -1 ||
    x.Description?.toLowerCase().indexOf(filterTerm) > -1 ||
    GetExternalTrackingNumber(x)?.toLowerCase().indexOf(filterTerm) > -1 ||
    x.PropertyKey?.toLowerCase().replaceAll('|', ' ').indexOf(filterTerm) > -1 ||
    x.Recipient?.AccountName?.toLowerCase().indexOf(filterTerm) > -1 ||
    x.Recipient?.Phone?.toLowerCase().indexOf(filterTerm) > -1 ||
    x.Recipient?.Email?.toLowerCase().indexOf(filterTerm) > -1 ||
    x.Recipient?.Name?.toLowerCase().indexOf(filterTerm) > -1 ||
    x.Recipient?.Meta['buyerId']?.Value.toLowerCase().indexOf(filterTerm) > -1 ||
    x.Service?.Name?.toLowerCase().indexOf(filterTerm) > -1 ||
    x.Tags?.filter((t) => t?.toLowerCase().indexOf(filterTerm) > -1).length > 0 ||
    x.BookingDetails?.Reference?.toLowerCase().indexOf(filterTerm) > -1 ||
    x.BookingDetails?.OrderLineId?.toLowerCase().indexOf(filterTerm) > -1 ||
    x.BookingDetails?.OrderId?.toLowerCase().indexOf(filterTerm) > -1 ||
    x.MarketplaceOrderLines?.filter((i) => {
      return (
        i.Product?.Sku?.toLowerCase().indexOf(filterTerm) > -1 ||
        i.Product?.Description?.toLowerCase().indexOf(filterTerm) > -1 ||
        i.Product?.TariffCode?.toLowerCase().indexOf(filterTerm) > -1 ||
        i.MarketplaceOrderId?.toLowerCase().indexOf(filterTerm) > -1 ||
        i.MarketplaceOrderLineId?.toLowerCase().indexOf(filterTerm) > -1 ||
        i.CustomerReference?.toLowerCase().indexOf(filterTerm) > -1
      );
    }).length > 0
  );
}
